const errors = {
  'errors.auth.invalid_email_or_password': 'user.error.wrong.username.password',
  'errors.auth.login_not_found': 'user.error.notfound.username',
  'errors.auth.reset_failed': 'user.error.password.reset',
  'authentication.web3.not_found': 'auth.web3.not.found',
  'authentication.web3.invalid_signature': 'auth.web3.invalid.signature',
  'authentication.web3.taken': 'auth.web3.taken',
  'username.has.already.been.taken': 'user.error.username.taken',
  'email.has.already.been.taken': 'user.error.email.taken',
};

export default errors;
